<template>
  <div class="min-h-screen flex">
    <div class="w-full lg:w-1/2 flex items-center justify-center bg-primary-bg ">
      <div class="w-full max-w-md p-8 space-y-6">
        <div class="flex justify-center ">
          <img src="../assets/images/uslu-logo.png" alt="" class="">
        </div>

        <div class="text-center">
          <p class="text-sm text-secondary-text mt-3">
            Giriş yapmak için lütfen bilgilerinizi girin!
          </p>
        </div>

        <form class="space-y-5" @submit.prevent="login">
          <div>
            <label class="block text-sm text-primary-text   mb-1">Kullanıcı Adı</label>
            <input type="text" v-model="email" class="w-full px-4 py-2 border rounded-lg  "
              placeholder="Kullanıcı adınızı giriniz" />
          </div>
          <div>
            <label class="block text-sm text-primary-text  mb-1">Şifre</label>
            <div class="relative">
              <input v-model="password" :type="showPassword ? 'text' : 'password'"
                class="w-full px-4 py-2 border rounded-lg  pr-10" placeholder="••••••••" />
              <span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                @click="togglePassword">
                <EyeIcon v-if="!showPassword" class="w-5 h-5" />
                <EyeSlashIcon v-else class="w-5 h-5" />
              </span>
            </div>
          </div>

          <!-- <div>
            <a href="#" class="text-sm text-primary-text dark:text-gray-100 hover:text-primary-text  ">Şifrenizi mi
              unuttunuz ?</a>
          </div> -->

          <button type="submit" class="w-full py-2 px-4  bg-gray-900 hover:bg-gray-800 text-white rounded-lg">Giriş
            Yap</button>
        </form>
      </div>
    </div>

    <div class="hidden md:flex">
      <div class="text-center">
        <img src="../assets/images/background.jpg" alt="logo" class=" mx-auto h-screen" />
      </div>
    </div>
  </div>
</template>

<script>
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline'
import auth from '@/stores/auth'
import { postApi } from "@/services/api";


export default {
  name: 'LoginPage',
  components: {
    EyeIcon,
    EyeSlashIcon
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      try {
        const formData = new URLSearchParams()
        formData.append('email', this.email)
        formData.append('password', this.password)

        const response = await postApi('/auth/login', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })

        const token = response.access_token || response.data?.access_token

        auth.setTokens(token)
        this.$router.push('/')

      } catch (error) {
        alert('Giriş başarısız!')
        console.error(error)
      }
    }
  }

}
</script>
